import React from 'react'
import 'tailwindcss/tailwind.css';
import 'font-awesome/css/font-awesome.min.css';
import Typed from 'react-typed';
import { useNavigate } from 'react-router-dom';

const Homepage = () => {
  const navigate = useNavigate();

  const handleStartLearning = () => {
    navigate('/signin');
  };

  return (
    <div className="text-white mt-[-50px]">
      <div
        className="
          w-full
          min-h-[100svh]
          max-w-[800px]
          mx-auto
          px-4 sm:px-6
          text-center
          flex flex-col
          justify-center
        "
      >
        <p className="text-transparent bg-gradient-to-r from-teal-400 via-blue-400 to-blue-600 bg-clip-text font-bold p-2">
          STUDY BETTER. STUDY SMARTER.
        </p>

        <div className="-mt-1 flex justify-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1">
            <span className="inline-flex items-center gap-2 text-xs text-white/80">
              Biology Beta
              <span className="inline-block h-2 w-2 rounded-full bg-blue-400 animate-pulse" />
              Free Early Access
            </span>
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold py-4 md:py-6">
          Learn with EduBahamas
        </h1>

        <div className="flex flex-wrap justify-center items-center gap-x-2">
          <p className="text-xl sm:text-2xl font-bold">
            Study, Learn and Practice For
          </p>

          <Typed
            className="
              text-transparent bg-gradient-to-r from-teal-400 via-blue-400 to-blue-600 bg-clip-text
              text-xl sm:text-2xl font-bold
            "
            strings={["BGSCE and BJC", "Sciences", "Mathematics", "History"]}
            typeSpeed={100}
            backSpeed={70}
            loop
          />
        </div>

        <button
          onClick={handleStartLearning}
          id="button-custom"
          className="
            mt-[30px]
            rounded-md
            mx-auto
            flex justify-center items-center
            w-full
            max-w-[320px]
            sm:w-[60%]
            md:w-[30%]
          "
        >
          Start Learning
        </button>
      </div>
    </div>
  )
}

export default Homepage
